import * as React from 'react';
import { Image, InlineText3, InlineText1 } from '@cian/ui-kit';

import * as styles from './footer.css';

interface IFooterProps {
  authorName?: string | null;
  authorLogoUrl: string;
  authorLabel: string;
  callback: React.ReactNode;
}

export function Footer({ authorName, authorLogoUrl, authorLabel, callback }: IFooterProps) {
  return (
    <div className={styles['footer']}>
      {authorLogoUrl && (
        <div className={styles['logo']}>
          <Image src={authorLogoUrl} objectFit="contain" />
        </div>
      )}

      <div className={styles['bottom']}>
        <div className={styles['description']}>
          <InlineText3 color="gray60_100">{authorLabel}</InlineText3>
          {authorName && <InlineText1>{authorName}</InlineText1>}
        </div>

        {callback}
      </div>
    </div>
  );
}
